import React, { useEffect } from "react";
import { YhPageHeader } from "@/components/YhPageHeader";
import { ISearchField, ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { ioFlagDs, tradeTypeDs, billCancelStatusDs } from "@/types/FmsDs";
import useGlobalModel from "@/model/globalModel";
import { useStatisticPurchaseModel } from "./statisticPurchaseModel";
import { TradeTypeEnum } from "@/types/FmsEnums";

export function PageHeader() {
    const {
        orgDs,
        beDs,
        // payMethodDs,
        searchParam,
        resetSearchParam,
        updateSearchParam,
        loadData
    } = useStatisticPurchaseModel();

    const { fetchSupplierList, getSelectedDict, appDs, shopDs, accountTypeDs } = useGlobalModel();


    const searchFields: ISearchField[] = [
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "系统分支",
            fieldName: "branch",
            size: "small",
            options: appDs,
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "门店",
            fieldName: "shopCode",
            size: "small",
            options: shopDs.map(item => ({ value: item.code, label: item.label })),
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "单据类型",
            fieldName: "tradeTypeCode",
            size: "small",
            options: [
                {
                    label: '采购单',
                    value: TradeTypeEnum.PURCHASE,
                },
                {
                    label: '采购退货单',
                    value: TradeTypeEnum.PURCHASE_RETURN,
                },
            ],
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "单据编号",
            fieldName: "tradeCode",
            size: "small",
        },
        {
            type: SearchTypeEnum.AsyncSelect,
            xxl: 4,
            span: 4,
            placeholder: "供应商",
            fieldName: "partnerCode",
            size: "small",
            selectfetchList: fetchSupplierList,
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "业务员",
            fieldName: "tradeOperator",
            size: "small",
        },
    ]

    const searchMoreFields: ISearchField[] = [
        {
            type: SearchTypeEnum.RangePicker,
            xxl: 8,
            span: 8,
            placeholder: "起止",
            fieldName: "time",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "账单编码",
            fieldName: "code",
            size: "small",
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "账户类型",
            fieldName: "accountTypeCode",
            size: "small",
            options: accountTypeDs,
        },
        // {
        //     type: SearchTypeEnum.TreeSelect,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "从属机构",
        //     fieldName: "orgCode",
        //     size: "small",
        //     treeDs: orgDs,
        // },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "销售实体",
            fieldName: "beCode",
            size: "small",
            options: beDs,
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     placeholder: "授信类型",
        //     fieldName: "creditFlag",
        //     size: "small",
        //     options: creditFlagDs(),
        // },

        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "客户",
        //     fieldName: "partnerCode",
        //     size: "small",
        //     options: customerDs,
        // },


        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     placeholder: "支付方式",
        //     fieldName: "payType",
        //     size: "small",
        //     options: payTypeOption,
        // },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "收支标识",
            fieldName: "ioFlag",
            size: "small",
            options: ioFlagDs,
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "账户编码",
            fieldName: "accountCode",
            size: "small",
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "状态",
            fieldName: "status",
            size: "small",
            options: [
                { label: "初始", value: "0" },
                { label: "已记账", value: "1" },
                { label: "已核销", value: "2" }
            ],
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "取消状态",
            fieldName: "cancelStatus",
            size: "small",
            options: billCancelStatusDs,
        },
    ]

    return (
        <YhPageHeader
            title="采购报表"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            searchMoreFields={searchMoreFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}